export enum LoginStatus {
    NUEVO = 'NUEVO',
    EXISTENTE = 'EXISTENTE',
}

export interface Paciente {
    dni: string;
    nombre: string;
    apellido: string;
	nombreCompleto?: string;
    email: string;
	telefono: string;
    password: string;
	prepaga: string;
	afiliadoNro: string;
	direccion: string;
	ciudad: string;
	provincia: number;
	codpostal: string;
	credito: number;
}
